module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAaCAYAAAC+aNwHAAABV0lEQVQ4T6WUzVGEQBCFHTiDZqBVwHkxAzKQDFwjcDNwzWAzEDMwBM0Az/xUmYHCGfA1NVCzwzQO5ZznffO6+/WIi38eQfo4jq/atk2qqnrbyhMkbprmHcKdEOIBkGwLRIRheOz7/mkSOY7zXJbl0RZy5mASwckrnOxtIGMP6ARBkA3DcL8VMgMYyIfneWme59+cmzOAhJzg5FERfPq+n3CQBUBC9oC82ECMAAby5bpuWhRFrpbDAugSRpxgxBSuSyn6ASRRIasAEkVRFHddR0EzQv4EKBBycq2MeUytFYBEMvJU/wxBObfWAD3yAI3jtQKYUoqAHSgbqwC55hTxOy7iLEBd80ls2lQjQI4ug3Cnd13fiQXANHes94H7aPRtTFEvvcwmj3WATusLtIitaaVHB9yM1/6BuTd4edP+L0pQm0Z/4RQQk122BLig5t3UdX2yFU73fgEUp9Ba58uTGwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/index/ic_right.png
// module id = 6FJI
// module chunks = 1